import { render, staticRenderFns } from "./receivers.vue?vue&type=template&id=008384c2&scoped=true"
import script from "./receivers.vue?vue&type=script&lang=js"
export * from "./receivers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008384c2",
  null
  
)

export default component.exports